import { render, staticRenderFns } from "./usageAgreement.vue?vue&type=template&id=0667cf90&scoped=true"
var script = {}
import style0 from "./usageAgreement.vue?vue&type=style&index=0&id=0667cf90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0667cf90",
  null
  
)

export default component.exports